// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.attachments-table-container {
  max-height: 300px; /* adjust as needed */
  overflow-y: auto;
}

.attachments-table-container {
  max-height: 300px;
  overflow-y: auto;
}

.attachments-table-container thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.attachments-table-container table th,
.attachments-table-container table td {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/attachments/job-attachments.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,iBAAA,EAAA,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,iBAAA;EACA,UAAA;AACF;;AAGA;;EAEE,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;AAAF","sourcesContent":[":host {\n  display: block;\n}\n\n.attachments-table-container {\n  max-height: 300px; /* adjust as needed */\n  overflow-y: auto;\n}\n\n.attachments-table-container {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.attachments-table-container thead th {\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 1;\n}\n\n\n.attachments-table-container table th,\n.attachments-table-container table td {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  vertical-align: middle;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
